
export enum ProductSnackbarMessage {
  UpdateProductFailed = 'An error occurred during the process.',
  UpdateProductSuccess = 'Product was successfully updated.',
  CreateProductSuccess = 'Product was successfully created.',
  CreateProductFailed = 'An error occurred during the process.',
}